/**
 * New catalog SKUs (not re-scrapes) should be promoted first.
 * Keep in sync with `src/utils/stagedPromotePriority.ts`.
 */

export function isPriorityNewStaged(product: {
  changeType?: string | null;
  existingCanonicalId?: string | null;
}): boolean {
  if (product.existingCanonicalId) return false;
  const changeType = String(product.changeType || 'new').trim() || 'new';
  return changeType === 'new';
}

export function comparePromotePriority(
  a: { changeType?: string | null; existingCanonicalId?: string | null },
  b: { changeType?: string | null; existingCanonicalId?: string | null },
): number {
  const an = isPriorityNewStaged(a) ? 0 : 1;
  const bn = isPriorityNewStaged(b) ? 0 : 1;
  return an - bn;
}
